import { ColorClass } from 'shared';

export class FlashMessage {
    public type: ColorClass;
    public title: string;
    public message: string;
}
